document.addEventListener("DOMContentLoaded", () => {

  const titleEl = document.querySelector("[data-product-title-id]");
  if (!titleEl) return;

  const defaultTitle = titleEl.textContent.trim();

  function getVariantData() {
    const scriptEl = document.querySelector("#variant-title-data");
    if (!scriptEl) return null;
    try { return JSON.parse(scriptEl.textContent); }
    catch { return null; }
  }

  function updateTitle(variantId) {
    const data = getVariantData();
    if (!data) return;

    const variantData = data[variantId];

    if (variantData && variantData.variant_title && variantData.variant_title !== "Default Title") {
      titleEl.textContent = `${defaultTitle} – ${variantData.variant_title}`;
    } else {
      titleEl.textContent = defaultTitle;
    }
  }

  // 1️⃣ Initial detection
  function detectInitialVariant() {
    // Ignite stores selected variant as JSON inside this element
    const selectedEl = document.querySelector("variant-selects [data-selected-variant]");
    if (!selectedEl) return;

    try {
      const variantObj = JSON.parse(selectedEl.innerHTML);
      if (variantObj && variantObj.id) {
        updateTitle(String(variantObj.id));
      }
    } catch (e) {
      console.warn("Could not parse initial variant", e);
    }
  }

  // 2️⃣ Ignite: variant changed event
  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail.variant;
    if (!variant) return;
    updateTitle(String(variant.id));
  });

  // 3️⃣ Fallback: default form change
  document.addEventListener("change", (event) => {
    if (event.target.name === "id") {
      updateTitle(String(event.target.value));
    }
  });

  // 4️⃣ Initial (URL-based variant)
  const initialVariantId = new URLSearchParams(window.location.search).get("variant");
  if (initialVariantId) {
    updateTitle(String(initialVariantId));
  } else {
    // If no URL variant → detect initial variant from the DOM
    detectInitialVariant();
  }
});



document.addEventListener("DOMContentLoaded", () => {

  const exportBtn = document.getElementById("cart-export-csv");
  if (!exportBtn) return;

  const formatEUR = cents =>
    (cents / 100).toFixed(2).replace(".", ",");

  const getTimestamp = () => {
    const d = new Date();
    const pad = n => String(n).padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}-${pad(d.getMinutes())}`;
  };

  exportBtn.addEventListener("click", async () => {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const header = [
        "SKU",
        "Name",
        "Anzahl",
        "Einzelpreis (€)",
        "Discount",
        "Reduzierter Preis (€)",
        "Summe (€)"
      ];

      const rows = cart.items.map(item => {
        const discounts = item.discounts.length
          ? item.discounts
              .map(d => `${d.title} (-${formatEUR(d.amount)} €)`)
              .join(" | ")
          : "";

        return [
          item.sku || "",
          `${item.product_title}${item.variant_title ? " – " + item.variant_title : ""}`,
          item.quantity,
          formatEUR(item.original_price),
          discounts,
          formatEUR(item.discounted_price),
          formatEUR(item.line_price)
        ];
      });

      const footer = [
        ["", "Zwischensumme", "", "", "", "", formatEUR(cart.items_subtotal_price)],
        ["", "Rabatte gesamt", "", "", "", "", "-" + formatEUR(cart.total_discount)],
        ["", "Gesamtsumme", "", "", "", "", formatEUR(cart.total_price)],
        [],
        ["", "!!! ACHTUNG: VERSANDKOSTEN SIND IN DIESER ÜBERSICHT NOCH NICHT ENTHALTEN !!!", "", "", "", "", ""]
      ];

      const csv = [
        header,
        ...rows,
        [],
        ...footer
      ]
        .map(row => row.map(v => `"${v}"`).join(";"))
        .join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `warenkorb-export-${getTimestamp()}.csv`;
      a.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("CSV-Export fehlgeschlagen", err);
      alert("Der Warenkorb konnte nicht exportiert werden.");
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const tilesRoot = document.querySelector(".species-facets");
  if (!tilesRoot) return;

  const WP_SPECIES_DEBUG = true;
  const WP_SPECIES_DEBOUNCE_MS = 250;
  let wpSpeciesClickTimer = null;
  let wpSpeciesSyncFrame = null;
  let wpSpeciesLastTile = null;

  function syncSpeciesTilesFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const speciesParam = "filter.p.m.custom.species";
    const activeValues = Array.from(params.entries())
      .filter(([k]) => k.includes(speciesParam))
      .map(([, v]) => v);

    document.querySelectorAll(".species-facets__item").forEach(item => {
      const input = item.querySelector('input[type="checkbox"]');
      const label = item.querySelector(".species-tile");
      if (!input || !label) return;
      const isActive = activeValues.includes(input.value);
      input.checked = isActive;
      label.classList.toggle("active", isActive);

      // Keep data-url in sync since tiles are outside facet re-rendering
      const url = new URL(window.location.href);
      const urlParams = url.searchParams;
      Array.from(urlParams.keys()).forEach(key => {
        if (key.includes(speciesParam)) {
          urlParams.delete(key);
        }
      });
      if (!isActive) {
        urlParams.set(input.name, input.value);
      }
      label.dataset.url = url.toString();
    });
  }

  function scheduleSpeciesSync() {
    if (wpSpeciesSyncFrame) return;
    wpSpeciesSyncFrame = requestAnimationFrame(() => {
      wpSpeciesSyncFrame = null;
      syncSpeciesTilesFromUrl();
    });
  }

  document.addEventListener("click", (e) => {
    const tile = e.target.closest(".species-tile");
    if (!tile) return;
    e.preventDefault();

    wpSpeciesLastTile = tile;
    if (wpSpeciesClickTimer) clearTimeout(wpSpeciesClickTimer);

    wpSpeciesClickTimer = setTimeout(() => {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      const speciesParam = "filter.p.m.custom.species";

      // Remove existing species filters
      Array.from(params.keys()).forEach(key => {
        if (key.includes(speciesParam)) {
          params.delete(key);
        }
      });

      // Apply the new species value (if any)
      const newUrl = new URL(wpSpeciesLastTile.dataset.url, window.location.origin);
      const newParams = newUrl.searchParams;
      let nextSpeciesValue = null;

      for (const [k, v] of newParams.entries()) {
        if (k.includes(speciesParam)) {
          params.set(k, v);
          nextSpeciesValue = v;
        }
      }

      // Keep tile state in sync since this block is outside the native facets DOM updates
      document.querySelectorAll(".species-facets__item").forEach(item => {
        const input = item.querySelector('input[type="checkbox"]');
        const label = item.querySelector(".species-tile");
        if (!input || !label) return;
        const isActive = nextSpeciesValue && input.value === nextSpeciesValue;
        input.checked = Boolean(isActive);
        label.classList.toggle("active", Boolean(isActive));
      });

      const facetForm = document.querySelector("facet-filters-form");
      if (facetForm && typeof facetForm.onSubmitForm === "function") {
        if (WP_SPECIES_DEBUG) {
          console.debug("[species] onSubmitForm", {
            params: params.toString(),
            nextSpeciesValue
          });
        }
        facetForm.onSubmitForm(params.toString(), e);
        return;
      }

      const FacetClass = customElements.get("facet-filters-form");
      if (FacetClass && typeof FacetClass.renderPage === "function") {
        if (WP_SPECIES_DEBUG) {
          console.debug("[species] renderPage", {
            params: params.toString(),
            nextSpeciesValue
          });
        }
        FacetClass.renderPage(params.toString(), e);
        return;
      }

      if (WP_SPECIES_DEBUG) {
        console.debug("[species] full reload", {
          params: params.toString(),
          nextSpeciesValue
        });
      }
      url.search = params.toString();
      window.location.href = url.toString();
    }, WP_SPECIES_DEBOUNCE_MS);
  });

  syncSpeciesTilesFromUrl();
  window.wpSyncSpeciesTilesFromUrl = syncSpeciesTilesFromUrl;
  window.addEventListener("popstate", syncSpeciesTilesFromUrl);

  if ("MutationObserver" in window) {
    let targetsObserver = null;

    function observeTargets() {
      if (targetsObserver) targetsObserver.disconnect();
      targetsObserver = new MutationObserver(() => {
        scheduleSpeciesSync();
      });

      const activeFacets = document.querySelector(".active-facets");
      if (activeFacets) targetsObserver.observe(activeFacets, { childList: true, subtree: true });

      const facetForm = document.querySelector("facet-filters-form");
      if (facetForm) targetsObserver.observe(facetForm, { childList: true, subtree: true });
    }

    observeTargets();

    // Re-attach when facets UI gets replaced by AJAX
    const rootObserver = new MutationObserver((mutations) => {
      const shouldRebind = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          return node instanceof Element &&
            (node.matches(".active-facets, facet-filters-form") ||
             node.querySelector(".active-facets, facet-filters-form"));
        });
      });

      if (shouldRebind) observeTargets();
    });

    rootObserver.observe(document.body, { childList: true, subtree: true });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  // Nur auf Collection-Seiten
  if (!document.body.classList.contains("collection-template")) return;

  document.addEventListener("click", (event) => {
    const link = event.target.closest('a[href^="/collections/"]');
    if (!link) return;

    // Respect other handlers (e.g., native facet remove) that already prevented default.
    if (event.defaultPrevented) return;

    // Skip native facets UI interactions.
    if (link.closest("facet-remove, .active-facets, facet-filters-form")) return;

    // Erlaubt explizite Reset-Links
    if (link.hasAttribute("data-reset-filters")) return;

    const speciesFilter = new URL(window.location.href)
      .searchParams
      .get("filter.p.m.custom.species");

    // Kein Species-Filter aktiv → nichts tun
    if (!speciesFilter) return;

    const targetUrl = new URL(link.href, window.location.origin);

    // Wenn Ziel schon Filter hat → nichts tun
    if (targetUrl.searchParams.has("filter.p.m.custom.species")) return;

    // Filter anhängen
    targetUrl.searchParams.set("filter.p.m.custom.species", speciesFilter);

    // Navigation kontrolliert ausführen
    event.preventDefault();
    window.location.href = targetUrl.toString();
  });
});


document.addEventListener("DOMContentLoaded", () => {

  // Nur auf Collection-Seiten
  if (!document.body.classList.contains("collection-template")) return;

  const url = new URL(window.location.href);
  const speciesParam = "filter.p.m.custom.species";

  // Kein Species-Filter aktiv → nichts tun
  if (!url.searchParams.has(speciesParam)) return;

  // Ignite markiert leere Collections explizit
  const emptyCollection = document.querySelector(
    "#product-grid.collection--empty"
  );

  if (!emptyCollection) return;

  // → Filter entfernen & Seite neu laden
  url.searchParams.delete(speciesParam);

  // replace = saubere History (kein Back-Loop)
  window.location.replace(url.toString());
});
